import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Suggest  } from '@blueprintjs/select';
import { MenuItem, FormGroup, Button, H3, H4, H6, ProgressBar } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';
import MaterialTable from 'material-table';
import { CsvBuilder } from "filefy";
import { rounded } from '../../../utils.js';
import ttest2 from '@stdlib/stats-ttest2';
import Statistics from 'statistics.js';

//import './DocStats.css';

//import { min } from 'lodash';

class DocStats extends React.PureComponent {

  state = {
    selectedDocId1:"",
    selectedDocId2:"",
    height:350,
    freq:0,
    docList:[],
    data1:{},
    data2:{},
    waitingForDocStats:false,
    statType:2,
    catFilter:"",
    selectedItem1:"",
    selectedItem2:"",
    selectedRel:"",
    statTable: [], // cumulative table of stats for various doc
    docs: [], // list of documents that are in statTable
  }

  dataShape=[
    { name:'specificLemmaCat',label:this.props.t('specificLemmaCat'),type:"dict" },
    { name:'relDist',label:this.props.t('relDist'),type:"num" },
    { name:'nbCls',label:this.props.t('nbCls'),type:"num" },
    { name:'nbToks',label:this.props.t('nbToks'),type:"num" },
    { name:'nbPunct',label:this.props.t('nbPunct'),type:"num" },
    { name:'nbForms',label:this.props.t('nbForms'),type:"num" },
    { name:'lexicalDensity',label:this.props.t('lexicalDensity'),type:"num" },
    { name:'propPunct',label:this.props.t('propPunct'),type:"num" },
    { name:'formLength',label:this.props.t('formLength'),type:"num" },

  ];

  componentDidMount() {
    this.fetchDocList();
  }

  fetchDocList = () => {
    const endpoint = process.env.REACT_APP_API_BASE +'/get_doc_list.ajax.php';
    
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ session_id:this.props.session_id }),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        if (data.titledocid) {
          this.setState({ docList: data.titledocid });
        } else if (data.docid) {
          this.setState({ docList: data.docid });
        }
      });
    })
  }


  // docN is "doc1" or "doc2"
  setSelectedDocId=(doc_selectedDocId,docN) => {
    const m1=doc_selectedDocId.match(/docId=(([^/]+)\/(.*)#(\d+#\d+))/i);
    if (!m1) {
      console.log(doc_selectedDocId, "pas trouvé docId=")
      return;
    }
    const selectedDocId=m1[1];
    const collection=m1[2];
    const fileId=m1[3];
    const intervalSentNum=m1[4];
    const vocJsonFile=this.props.vocJsonFile;
    const language=this.props.language;
    const session_id=this.props.session_id;
    const globalNbToks=this.props.globalNbToks;

    const data={session_id,language,collection,fileId,intervalSentNum,vocJsonFile,globalNbToks};

    const endpoint = process.env.REACT_APP_API_BASE +'/get_doc_stats.ajax.php';
    
    this.setState({ waitingForDocStats:true });
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        const statTable=this.state.statTable;
        const { nbToks, nbForms, nbContentWords, nbPunct, nbCls, nbSents, nbParas, averageFirstSentLengths, averageLastSentLengths, formLength } = data;
        // statTable initialization
        // at each new doc, the stats will be added in the table as a new column
        if (statTable.length===0) {
          statTable.push(
            { label:this.props.t('paraNumber')},
            { label:this.props.t('sentNumber')},
            { label:this.props.t('clsNumber')},
            { label:this.props.t('tokenNumber')},
            { label:this.props.t('formNumber')},
            { label:this.props.t('contentWordNumber')},
            { label:this.props.t('punctNumber')},
            { label:this.props.t('formLength')},
            { label:this.props.t('averageFirstSentLengths')},
            { label:this.props.t('averageLastSentLengths')},
          );
        }
        // adding new stats in statTable for new doc
        
        statTable[0][docN]=Number(nbParas);
        statTable[1][docN]=Number(nbSents);
        statTable[2][docN]=Number(nbCls);
        statTable[3][docN]=Number(nbToks);
        statTable[4][docN]=Number(nbForms);
        statTable[5][docN]=Number(nbContentWords);
        statTable[6][docN]=Number(nbPunct);
        statTable[7][docN]=Number(formLength);
        statTable[8][docN]=Number(averageFirstSentLengths);
        statTable[9][docN]=Number(averageLastSentLengths);

        if (docN==="doc1") {
          this.setState({ 
            data1 : data,
            statTable : statTable,
            waitingForDocStats : false, 
            selectedDocId1 : selectedDocId, 
            selectedItem1 : doc_selectedDocId,
          });
        } else {
          this.setState({ 
            data2 : data,
            statTable : statTable,
            waitingForDocStats : false, 
            selectedDocId2 : selectedDocId, 
            selectedItem2 : doc_selectedDocId,
          });          
        }
      });
    })
  }

  // if statType = specificLemma, the arg. lemma must be given
  calcValues = (data,lemmaOrRel) => {
    if (! data.docStats) {
      return [];
    }

    const values=this.state.statType < 2 ? // if statType = specificLemma
                  data.docStats.map( tab =>  tab[ this.state.statType ][lemmaOrRel]? 
                                                        tab[ this.state.statType ][lemmaOrRel]:
                                                        0 ):
                  data.docStats.map( tab => tab[ this.state.statType ] );
    
    // the average form length must not take into account the 0 length sentences
    if (! values) {
      return [];
    } else {
      if (this.state.statType===8 || this.state.statType===6) {
        return values.filter( val => val > 0); 
      }
      return values;
    }
  }

  
  selectRelation=(e)=>{
    e.preventDefault();
    const { value } = e.target;
    this.setState({selectedRel:value});
  }
  
  clearTable = () => {
    this.setState( { data1:{}, data2:{}, selectedDocId1: "", selectedDocId2:"", statTable:[] })

  }

  
  render() {

    const { t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    const items=this.state.docList;
    //const { nbToks, nbForms, nbContentWords, nbPunct, nbCls, nbSents, nbParas, averageFirstSentLengths, averageLastSentLengths, formLength } = this.state.data;
    const nbToks1 = this.state.data1.nbToks;

    const statTypeOptions=this.dataShape.map( obj=> obj.label);
    statTypeOptions.shift();

    const listRels=this.state.data1.relDist ? Object.keys(this.state.data1.relDist).sort(): [];
    var globalAverage1;
    var globalStdDev1;
    var globalAverage2;
    var globalStdDev2;
    var values1=[];
    var values2=[];
    var min1;
    var max1;
    var min2;
    var max2;
    var serieName="";
    var ttest;
    var utest;
    var n1;
    var n2;
    var z;
    var u;
    var p;
    var d;
    var effectSizeLabel;
    

    // numerical series : nbCls, etc.
    if (this.state.data1['average'] && this.state.data2['average']) {
      if (this.state.statType>1) {
        serieName=this.dataShape[this.state.statType].name;
        values1=this.calcValues(this.state.data1);
        values2=this.calcValues(this.state.data2);
      }  else if (this.state.statType===1 && this.state.selectedRel) {
        serieName="distRel_"+this.state.selectedRel;
        values1=this.calcValues(this.state.data1,this.state.selectedRel);
        values2=this.calcValues(this.state.data2,this.state.selectedRel);
      }
      if (values1.length>0 && values2.length>0 ) { 
        globalAverage1=this.state.data1["average"][serieName];
        globalStdDev1=Math.sqrt(this.state.data1["variance"][serieName]);
        globalAverage2=this.state.data2["average"][serieName];
        globalStdDev2=Math.sqrt(this.state.data2["variance"][serieName]);

        d=Math.abs(2*(globalAverage1-globalAverage2)/(globalStdDev1+globalStdDev2));
        //https://www.bstat-chu.uliege.be/upload/docs/application/pdf/2023-06/bstat-midis-biostat_-_version_26-05-2023_2023-06-07_11-30-39_634.pdf
        effectSizeLabel=  (d<0.1)? "verySmall":
                          (d<0.4)? "small":
                          (d<0.65)? "medium":
                          (d<0.9)? "large":
                          (d<1.5)? "veryLarge":
                          "huge";
        console.log(values1);
        console.log(values2);

        // on utilise l'opérateur destructurant (destructuring assignment) car min veut des entiers déballés
        min1=Math.min(...values1);
        max1=Math.max(...values1);
        min2=Math.min(...values2);
        max2=Math.max(...values2);
        ttest=ttest2(values1,values2);
        
        n1=values1.length;
        n2=values2.length;
       
        // calcul de mannWhitney avec le module stats
        var testVars = {
          serie: 'nominal',
          value: 'metric'
        }
        const testData=[];
        for (var val of values1) {
          testData.push({serie:"serie1",value:val});
        }
        for (val of values2) {
          testData.push({serie:"serie2",value:val});
        }

        var stats = new Statistics(testData, testVars);
        utest = stats.mannWhitneyU('serie', 'value');
        u=utest? utest['MannWhitneyU']:0;
        z=Math.min(Math.abs(u-n1*n2/2)/Math.sqrt(n1*n2*(n1+n2+1)/12),4);
        console.log(z);
        p=2*(1-stats.normalCumulativeValue(Math.abs(z)));

      }
    }

    // preparation of the table that includes the various doc stats
    const fields=["measure"];
    const columns=[
      { 
        title: t('docId'), 
        field: 'label',
      }
    ];
    
    if (this.state.selectedDocId1) {
      columns.push(
        { 
          title: this.state.selectedDocId1, 
          field: "doc1", 
          render: rowData => Intl.NumberFormat(langFormat, { useGrouping: true }).format(rowData["doc1"]),
          cellStyle: {
            textAlign:'center',
          },
        }
      )
      fields.push(this.state.selectedDocId1);
    }
    if (this.state.selectedDocId2) {
      columns.push(
        { 
          title: this.state.selectedDocId2, 
          field: "doc2", 
          render: rowData => Intl.NumberFormat(langFormat, { useGrouping: true }).format(rowData["doc2"]),
          cellStyle: {
            textAlign:'center',
          },
        }
      )
      fields.push(this.state.selectedDocId2);
    }

    return(
      <>
          <Paper className="margin-bottom-1-5-rem padding-1-rem">
            <H3>{t('selectTwoDocs')}&nbsp;

              <Suggest 
                width={300}
                items={items} 
                selectedItem={this.state.selectedDocId1} 
                itemPredicate={(query, doc, _index, exactMatch) => { 
                  const normalizedTitle = doc ? doc.toLowerCase():""; 
                  const normalizedQuery = query? query.toLowerCase():"";

                  if (exactMatch) { 
                      return normalizedTitle === normalizedQuery; 
                  } else { 
                      return normalizedTitle.includes(normalizedQuery) 
                  } 
                }} 
                itemRenderer={(item, itemProps) => { 
                    return ( 
                        <MenuItem 
                            key={item} 
                            value={item}
                            text={item} 
                            onClick={(e) => { 
                              this.setSelectedDocId(e.target.textContent,"doc1"); 
                            }} 
                            active={itemProps.modifiers.active} 
                        /> 
                    ); 
                }} 
                onItemSelect={() => { }} 
                tagRenderer={(item) => item} 
                inputValueRenderer={(item) => item.toString()} 
              />

              <Suggest 
                width={300}
                items={items} 
                selectedItem={this.state.selectedDocId2} 
                itemPredicate={(query, doc, _index, exactMatch) => { 
                  const normalizedTitle = doc ? doc.toLowerCase():""; 
                  const normalizedQuery = query? query.toLowerCase():"";

                  if (exactMatch) { 
                      return normalizedTitle === normalizedQuery; 
                  } else { 
                      return normalizedTitle.includes(normalizedQuery) 
                  } 
                }} 
                itemRenderer={(item, itemProps) => { 
                    return ( 
                        <MenuItem 
                            key={item} 
                            value={item}
                            text={item} 
                            onClick={(e) => { 
                              this.setSelectedDocId(e.target.textContent,"doc2"); 
                            }} 
                            active={itemProps.modifiers.active} 
                        /> 
                    ); 
                }} 
                onItemSelect={() => { }} 
                tagRenderer={(item) => item} 
                inputValueRenderer={(item) => item.toString()} 
              />

            </H3>
         
            {  this.state.waitingForDocStats && 
              <div>
                <br/>
                <br/>
                < ProgressBar />
              </div> }

            { ! this.state.waitingForDocStats && 
              <>
                <br/>
                { nbToks1 && this.state.selectedDocId1 &&
                  <>  
                    <H6>{t('keyCaracteristics')}</H6>
                    <br/>
                    { this.state.selectedDocId1 && 
                      <Button text={t('clearTable')} onClick={this.clearTable} />
                    }
                    <MaterialTable
                        title={t('statistics')}
                        columns={columns}
                        data={this.state.statTable}
                        options={{
                          filtering: false,
                          search: false,
                          sorting: false,
                          exportButton: true,
                          exportAllData: true,
                          paging: false,
                          padding: 'dense',
                        }}
                        components={{
                          exportCsv: (columns, data) => {
                            const fileName = "doc_stats";
                            const builder = new CsvBuilder(
                                fileName + ".csv"
                            );
                            builder
                                .setColumns( Object.keys(fields).sort() )
                                .setDelimeter(this.props.csvDelimiter).addRows(
                                  data.map((rowData) => Object.keys(fields).sort().map(key=>rowData.key))
                                )
                                .exportFile();
                          },
                          Container: props => (
                            <Paper
                              {...props}
                              elevation={0}
                            />
                          ),
                        }}
                    />
                    {/* <ul>
                        <li>{t('paraNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbParas)}</li>
                        <li>{t('sentNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbSents)}</li>
                        <li>{t('clsNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbCls)}</li>                        
                        <li>{t('tokenNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbToks)}</li>
                        <li>{t('formNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbForms)}</li>
                        <li>{t('contentWordNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbContentWords)}</li>                                                                        
                        <li>{t('punctNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbPunct)}</li>   
                        <li>{t('formLengthColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(formLength)}</li>                                                                     
                        <li>{t('averageFirstSentLengths')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(averageFirstSentLengths)}</li>                                                                        
                        <li>{t('averageLastSentLengths')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(averageLastSentLengths)}</li>                                                                        
                    </ul> */}
                  </>
                }

                <br/>
                <br/>
                { this.state.selectedItem1 && 
                    <>
  
                      <EnhancedSingleSelect
                        label={t('statType')}
                        name='statType'  // name is also used to make the input's `id`
                        hasDefault={true}
                        hasSelectableDefault={false}
                        options={statTypeOptions}
                        value={this.dataShape[this.state.statType].label}
                        onChange={ (e) => {
                                            e.preventDefault();
                                            const { value } = e.target;
                                            this.setState({ statType : statTypeOptions.indexOf(value)+1 });
                                          }
                                  }
                      />

  
                      {/* Distance des relations */}
                      { this.state.statType===1 &&
                        <>
                          <FormGroup>
                            <EnhancedSingleSelect
                              label={t('selectRelation')}
                              name='selectedRel'  // name is also used to make the input's `id`
                              hasDefault={true}
                              hasSelectableDefault={false}
                              options={listRels}
                              value={this.state.selectedRel}
                              onChange={this.selectRelation}
                            />
                          </FormGroup>
                        </>                     
                      }

                      { values1.length>0 && values2.length>0 &&
                        <>
                          <MaterialTable
                            title={this.dataShape[this.state.statType].label}
                            columns={columns}
                            data={ [
                              { 'label':t('min'), "doc1":min1,"doc2":min2 },
                              { 'label':t('max'), "doc1":max1,"doc2":max2 },
                              { 'label':t('average'), "doc1":globalAverage1,"doc2":globalAverage2 },
                              { 'label':t('stdDeviation'), "doc1":globalStdDev1,"doc2":globalStdDev2 },

                            ] }
                            options={{
                              filtering: false,
                              search: false,
                              sorting: false,
                              exportButton: true,
                              exportAllData: true,
                              paging: false,
                              padding: 'dense',
                            }}
                            components={{
                              exportCsv: (columns, data) => {
                                const fileName = "doc_stats";
                                const builder = new CsvBuilder(
                                    fileName + ".csv"
                                );
                                builder
                                    .setColumns( Object.keys(fields).sort() )
                                    .setDelimeter(this.props.csvDelimiter).addRows(
                                      data.map((rowData) => Object.keys(fields).sort().map(key=>rowData.key))
                                    )
                                    .exportFile();
                              },
                              Container: props => (
                                <Paper
                                  {...props}
                                  elevation={0}
                                />
                              ),
                            }}
                          />
                          <br/><br/>
                          <H4>T-test - Welch ({t('WelchExplanation')})</H4>
                          <br/>
                          <p>{t('nullHypothesis')}</p>
                          <p>t = {rounded(ttest['statistic'],4)}</p>
                          <p>n1 = {values1.length}, n2 = {values2.length}</p>
                          <p>pValue = {rounded(ttest['pValue'],4)}</p>
                          <p>{t('confidenceInterval')} (95%) = [{rounded(ttest['ci'][0],2)},{rounded(ttest['ci'][1],2) }] </p>
                          <p>{t('decision')} : { ttest['pValue'] < 0.05 ? t('rejected'): t('notRejected') }</p>
                        
                          <br/><br/>
                          <H4>Test U - Mann Whitney ({t('UExplanation')})</H4>
                          <br/>
                          <p>{t('nullHypothesis')}</p>
                          <p>u = {rounded(utest['MannWhitneyU'],4)}</p>
                          <p>pValue = {rounded(p,4)}</p>
                          <p>{t('decision')} : { p < 0.05 ? t('rejected'): t('notRejected') }</p>
                        
                          <br/><br/>
                          <H4>{t('effectSize')}</H4>
                          <p>d Cohen = {rounded(d,4)} - {t(effectSizeLabel)}</p>
                        </>
                      }   
                      
                  </>
                }
            </>
          }
        </Paper>

            
      </>
    );
  }

}

DocStats.propTypes = {
  subCorpora: PropTypes.array,
  session_id: PropTypes.string,
  language: PropTypes.string,
  globalNbToks: PropTypes.number,
  vocJsonFile: PropTypes.string,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(DocStats);
